/**
 * Generates a unique idempotency key for a request
 * Uses crypto.randomUUID() for secure UUID generation
 */
export const generateIdempotencyKey = (): string => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Header name for idempotency key
 */
export const IDEMPOTENCY_HEADER = "x-idempotency-key";
